// @flow
import LoadingButton from '@mui/lab/LoadingButton';
import type { buttonType } from '@shared/model/components';

function Button({
	loading,
	startIcon,
	endIcon,
	onClick,
	children,
	...buttonProps
}: buttonType): React$Node {
	return (
		<LoadingButton
			{...buttonProps}
			loading={loading}
			startIcon={startIcon}
			endIcon={endIcon}
			onClick={onClick}
		>
			{children}
		</LoadingButton>
	);
}

export default Button;
